__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalCalendar";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("lodash", "4.17.21", () => (__webpack_require__.e(486).then(() => (() => (__webpack_require__(96486))))));
			register("moment-timezone", "0.5.43", () => (Promise.all([__webpack_require__.e(346), __webpack_require__.e(700)]).then(() => (() => (__webpack_require__(80008))))));
			register("react-dom", "17.0.1", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(522)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(216), __webpack_require__.e(601)]).then(() => (() => (__webpack_require__(28216))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(197), __webpack_require__.e(410)]).then(() => (() => (__webpack_require__(60197))))));
			register("react", "17.0.1", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(67294))))));
			initExternal(14403);
			initExternal(2587);
			initExternal(66772);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};